var map = {
	"./CursoPeriodos": [
		"1e0e",
		"chunk-661ebf48",
		"chunk-2d0b687f"
	],
	"./CursoPeriodos.vue": [
		"1e0e",
		"chunk-661ebf48",
		"chunk-2d0b687f"
	],
	"./Cursos": [
		"1a41",
		"chunk-2d0b59c3"
	],
	"./Cursos.vue": [
		"1a41",
		"chunk-2d0b59c3"
	],
	"./CursosList": [
		"ec3f",
		"chunk-2d2304a7"
	],
	"./CursosList.vue": [
		"ec3f",
		"chunk-2d2304a7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "faa4";
module.exports = webpackAsyncContext;